// extracted by mini-css-extract-plugin
module.exports = {"price-formatter":"PriceFormatter_price-formatter__3oCAP","priceFormatter":"PriceFormatter_price-formatter__3oCAP"};